export default __webpack_public_path__ + "d909234a7a42163e03728140c1a81102.png";